import { EmptyStatesIllustration } from "@cdkglobal/radial";
import { useIntl } from "react-intl";
import { RowDataReducerState, RowDataReducerAction } from "../../types";
import { EmptyStateContainer, EmptyStateText } from "../../utils/styled";
import Loader from "../common/Loader";
import RecordPage from "./components/record-page/RecordPage";
import SetupTable from "./components/setup/SetupTable";
import SetupsDashboard from "./components/setups-dashboard/SetupsDashboard";

interface LandingPageContentProps {
  isFetchingUserData: boolean;
  isLoading: boolean;
  isSetupSelected: boolean;
  isRecordOpen: boolean;
  shouldShowEmptyState: boolean;
  rowDataReducerState: RowDataReducerState;
  dispatch: React.Dispatch<RowDataReducerAction>;
}

export default function LandingPageContent({
  isFetchingUserData,
  isLoading,
  isSetupSelected,
  isRecordOpen,
  shouldShowEmptyState,
  rowDataReducerState,
  dispatch,
}: Readonly<LandingPageContentProps>): JSX.Element {
  const { formatMessage } = useIntl();

  if (isFetchingUserData) {
    return <div>Loading user data...</div>;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!isSetupSelected) {
    return <SetupsDashboard />;
  }

  if (isRecordOpen) {
    return (
      <RecordPage
        rowDataReducerState={rowDataReducerState}
        dispatch={dispatch}
      />
    );
  }

  if (shouldShowEmptyState) {
    return (
      <EmptyStateContainer>
        <EmptyStatesIllustration dataTestId="empty-state" size={400} />
        <EmptyStateText>
          <p style={{ margin: 0 }}>
            {formatMessage(
              {
                id: "emptyState.noData",
                defaultMessage:
                  "There's no data to display yet.{br}Select a store to get started.",
              },
              { br: <br /> },
            )}
          </p>
        </EmptyStateText>
      </EmptyStateContainer>
    );
  }

  return (
    <SetupTable rowDataReducerState={rowDataReducerState} dispatch={dispatch} />
  );
}
